<template>
    <span>
        <!-- <b class="text-amazon-500 font-black relative z-10"> نُرس </b>
        <b class="text-vista-500 font-bold relative -right-3 -top-0.5 z-10"> لــند </b> -->
        <b class="font-bold" :class="twMerge('text-amazon-700', className)"> نُرس </b>
        <b class="font-bold" :class="twMerge('text-amazon-700', className)"> لند </b>
    </span>
</template>

<script lang="ts" setup>
import { twMerge } from "tailwind-merge";

const props = defineProps({
    className: String,
});
</script>

<style></style>
